import { z } from "zod";

import { getSectionDisplayOptionsSchema } from "../display-options";

export const aboutDisplayOptionsSchema = getSectionDisplayOptionsSchema("about");
export type AboutDisplayOptions = z.infer<typeof aboutDisplayOptionsSchema>;

export const aboutContentSchema = z.object({
  heading: z.string().max(200).optional(),
  body: z.string().max(10000),
  highlights: z
    .array(
      z.object({
        label: z.string().max(100),
        value: z.string().max(200),
      })
    )
    .max(10)
    .optional(),
  displayOptions: aboutDisplayOptionsSchema.optional(),
});

export type AboutContent = z.infer<typeof aboutContentSchema>;
